"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetAndResetTradePwdRequest = void 0;
var SetAndResetTradePwdRequest = /** @class */ (function () {
    function SetAndResetTradePwdRequest() {
    }
    return SetAndResetTradePwdRequest;
}());
exports.SetAndResetTradePwdRequest = SetAndResetTradePwdRequest;
;
//# sourceMappingURL=setAndResetTradePwd.request.js.map